import { render, staticRenderFns } from "./ContractInfo.vue?vue&type=template&id=72831abe&scoped=true"
import script from "./ContractInfo.vue?vue&type=script&lang=js"
export * from "./ContractInfo.vue?vue&type=script&lang=js"
import style0 from "./ContractInfo.vue?vue&type=style&index=0&id=72831abe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72831abe",
  null
  
)

export default component.exports